import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import {
  DataCollectionApi,
  PrivacyConsentsRequest,
} from "../../orchestrator-api-client";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export const submitPrivacyConsents = createAsyncThunk<
  PrivacyConsentsRequest,
  PrivacyConsentsRequest,
  ThunkApi
>("submitPrivacyConsents", async (privacyData, { rejectWithValue }) => {
  try {
    await new DataCollectionApi().addPrivacy(privacyData);

    return privacyData;
  } catch (error: any) {
    pushErrorMonitor(error); //send error push monitor
    const err: LayoutError = {
      title: "Salvataggio consensi privacy",
      description:
        "Non siamo riusciti a salvare i tuoi consensi per la privacy.\n Puoi riprovare o contattare il supporto",
      error: error.message,
    };
    return rejectWithValue(err);
  }
});
